import watchSetPermission from './addPermission';

const watchEditPermission = [watchSetPermission];

export default watchEditPermission;
